import { AudioRecordingTranscriptStatus } from "@/store/audio/transcription/audio-transcription.types";

import type { TranscriptSourceResolution } from "./audio-pipeline.types";

/**
 * Pure decision: can we use the local transcript, or do we need to
 * retranscribe from the uploaded source? Missing and Compromised both route
 * to retranscribe; only Ready goes local.
 */
export function resolveTranscriptSource({
  transcriptStatus,
}: {
  transcriptStatus: AudioRecordingTranscriptStatus;
}): TranscriptSourceResolution {
  return transcriptStatus === AudioRecordingTranscriptStatus.Ready ? "local" : "retranscribe";
}
